import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// ----- public -----
export const subscribeEmail = (email, captchaToken, website = "") =>
  api
    .post("/subscribers", { email, captcha_token: captchaToken, website })
    .then((r) => r.data);

export const submitEnquiry = (payload) =>
  api.post("/contact", payload).then((r) => r.data);

export const submitCareer = (fields, file) => {
  const fd = new FormData();
  Object.entries(fields).forEach(([k, v]) => {
    if (v !== undefined && v !== null) fd.append(k, v);
  });
  if (file) fd.append("cv", file);
  return api
    .post("/careers", fd, { headers: { "Content-Type": "multipart/form-data" } })
    .then((r) => r.data);
};

// ----- admin -----
// NOTE on token storage: the admin JWT lives in localStorage. This is standard
// for SPAs with no SSR/cookie session layer, but it is theoretically vulnerable
// to XSS. The XSS surface here is small (no user-generated HTML is rendered),
// and the alternative (httpOnly cookies) requires CSRF protection and backend
// session handling. If you ever start rendering arbitrary user input, migrate
// admin auth to httpOnly cookies + CSRF tokens.
const TOKEN_KEY = "tafra_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

const authHeaders = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password }).then((r) => r.data);

export const adminMe = () =>
  api.get("/admin/me", { headers: authHeaders() }).then((r) => r.data);

export const adminListSubscribers = () =>
  api.get("/admin/subscribers", { headers: authHeaders() }).then((r) => r.data);

export const adminListContact = () =>
  api.get("/admin/contact", { headers: authHeaders() }).then((r) => r.data);

export const adminStats = () =>
  api.get("/admin/stats", { headers: authHeaders() }).then((r) => r.data);

export const adminListCareers = () =>
  api.get("/admin/careers", { headers: authHeaders() }).then((r) => r.data);

export const adminDownloadCareerCV = async (appId, filename) => {
  const res = await api.get(`/admin/careers/${appId}/cv`, {
    headers: authHeaders(),
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || `cv-${appId}`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const adminDownload = async (path, filename) => {
  const res = await api.get(path, {
    headers: authHeaders(),
    responseType: "blob",
  });
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};
